module.exports = __webpack_public_path__ + "img/logo-header.46ba7dc7.svg";